<template>
    <div>
        <v-row v-if="anio_lectivo > 0">
            <v-col>
                <v-tabs v-model="tab" class="rounded-lg" centered active-class="tab-active" slider-color="#ffbc00">
                    <v-tab class="font-weight-black">Niveles</v-tab>
                    <v-tab class="font-weight-black">grados</v-tab>
                </v-tabs>
                <v-tabs-items v-model="tab" touchless>
                    <v-tab-item class="my-4">
                        <niveles></niveles>
                    </v-tab-item>

                    <v-tab-item class="my-4">
                        <grados></grados>
                    </v-tab-item>
                </v-tabs-items>
            </v-col>
        </v-row>


        <v-col cols="12" v-else>
            <v-alert color="#ffbc00" icon="fas fa-exclamation-triangle" dark border="left" prominent elevation="5" dense>
                <span class="font-weight-black">
                    No existe año lectivo configurado, configure el año lectivo para acceder a niveles y grados.
                </span>
            </v-alert>
        </v-col>

    </div>
</template>



<script>
import niveles from '@/views/Administrativo/NivelesyGrados/components/niveles.vue'
import grados from '@/views/Administrativo/NivelesyGrados/components/grados.vue'

export default {
    components: {
        niveles,
        grados
    },


    data: () => ({
        dataLogin: sessionStorage,
        tab: 0,
        anio_lectivo: sessionStorage.id_ano_lectivo,
    }),



}
</script>